import React from 'react';
import "@/App.css";
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Amenities from './components/Amenities';
import VrindavanAttractions from './components/VrindavanAttractions';
import Testimonials from './components/Testimonials';
import Temples from './components/Temples';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <About />
        <Gallery />
        <Amenities />
        <VrindavanAttractions />
        <Testimonials />
        <Temples />
        <Contact />
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
